// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606180015/js/" + chunkId + "." + {"44":"3275f762","225":"803c246d","481":"f92be8d9","486":"edd2e2e0","770":"3a0f672e"}[chunkId] + ".0.7284848486315759.chunk.js";
};